<template>
	<div>
		<!-- 编辑记录 -->
		<div class="content1">
			<div class="all">
				<!-- <el-button size="small" @click="backtrack">返回</el-button> -->
				<div class="peopleUserInfo">
					<el-form
						:model="ruleForm"
						:rules="rules"
						ref="ruleForm"
						size="small"
						label-width="100px"
						class="demo-ruleForm"
					>
						<div class="peopleUserList">
							<div class="title">基本信息</div>
							<div>
								<el-row :gutter="24">
									<el-col :span="12">
										<el-form-item
											label="户主姓名:"
											prop="residentName"
										>
											<el-input
												placeholder="请输入"
												v-model="ruleForm.residentName"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item
											label="户主电话:"
											prop="mobile"
										>
											<el-input
												placeholder="请输入"
												v-model="ruleForm.mobile"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item
											label="身份证号:"
											prop="idnumber"
										>
											<el-input
												placeholder="请输入"
												v-model="ruleForm.idnumber"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item
											label="用户分类:"
											prop="userType"
										>
											<el-select
												style="width: 100%"
												v-model="ruleForm.userType"
												clearable
												filterable
												placeholder="请选择用户分类"
											>
												<el-option
													v-for="item in userTypes"
													:key="item.id"
													:label="item.name"
													:value="item.id"
												>
												</el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item
											label="片区:"
											prop="addrs"
										>
											<el-cascader
												style="width: 100%"
												clearable
												v-model="ruleForm.addrs"
												:options="taskAddrdata"
                        						filterable
												:props="{
													value: 'trueId',
													label: 'name',
													disabled: 'disable'
												}"
											></el-cascader>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item
											label="地址:"
											prop="address"
										>
											<el-input
												placeholder="请输入"
												v-model="ruleForm.address"
												@blur="changeAddress"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="12" >
										<el-form-item
											label="地址描述:"
											prop="addressDescribe"
										>
											<el-input
												type="text"
												placeholder="请输入"
												maxlength="30"
												show-word-limit
												v-model="ruleForm.addressDescribe"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item
											label="地理位置:"
										>
											<el-input
												placeholder="请输入"
												v-model="ruleForm.addressCoordDetail"
												@focus="chooseLocation"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item
											label="是否点火:"
											prop="fireState"
										>
										<el-radio v-model="ruleForm.fireState" label="1">已点火</el-radio>
  										<el-radio v-model="ruleForm.fireState" label="2">未点火</el-radio>
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item
											label="图片:"
										>
										<el-upload
											ref="upload"
											action="#"
											:auto-upload="true"
											:http-request="repairBeforUploadFun"
											list-type="picture-card"
											:on-preview="handlePictureCardPreview"
											:on-remove="handleRemove"
											:before-upload="beforUploadImg"
											:on-change="beforHFhandleChangeImg"
											:file-list="repairBeforFilefileList"
											accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP"
											:limit="20"
											:on-exceed="msgLimit"
											>
											<div style="height: 20px">
												<img src="../../../assets/image/upload.png" />
											</div>
											<div>
												<span>上传图片</span>
											</div>
											<!-- <i class="el-icon-plus"></i> -->
											</el-upload>
										</el-form-item>
									</el-col>
								</el-row>
							</div>
						</div>
						<div class="peopleUserList">
							<div class="title">安检信息</div>
							<div>
								<el-row :gutter="24">
									<el-col :span="12">
										<el-form-item label="安检联系人:">
											<el-input
												placeholder="请输入安检联系人"
												v-model="ruleForm.contactName"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="联系电话:">
											<el-input
												placeholder="请输入联系电话"
												v-model="ruleForm.contactMobile"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="是否为租户:">
											<el-radio-group
												v-model="ruleForm.islessee"
											>
												<el-radio :label="1"
													>是</el-radio
												>
												<el-radio :label="0"
													>否</el-radio
												>
											</el-radio-group>
										</el-form-item>
									</el-col>
								</el-row>
							</div>
						</div>
						<div class="peopleUserList">
							<div class="title">表具信息</div>
							<div>
								<el-row :gutter="24">
									<el-col :span="12">
										<el-form-item label="表号:">
											<el-input
												placeholder="请输入"
												v-model="ruleForm.sheetSteel"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="燃气表类型:">
											<el-select
												style="width: 100%"
												v-model="ruleForm.tableType"
												clearable
												filterable
												placeholder="请选择燃气表类型"
											>
												<el-option
													v-for="item in tableTypeData"
													:key="item.id"
													:label="item.name"
													:value="item.id"
												>
												</el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="表向:">
											<el-select
												style="width: 100%"
												v-model="
													ruleForm.tableDirection
												"
												clearable
												filterable
												placeholder="请选择表向"
											>
												<el-option
													v-for="item in tableDirectionData"
													:key="item.id"
													:label="item.name"
													:value="item.id"
												>
												</el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="燃气表厂家:">
											<el-select
												style="width: 100%"
												v-model="ruleForm.tableVender"
												clearable
												filterable
												placeholder="请选择燃气表厂家"
											>
												<el-option
													v-for="item in tableVenderData"
													:key="item.id"
													:label="item.name"
													:value="item.id"
												>
												</el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="防盗卡号:">
											<el-input
												placeholder="请输入"
												v-model="ruleForm.tableTitles"
											></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="点火日期:">
											<el-date-picker
												style="width: 100%"
												v-model="ruleForm.openDate"
                        type="datetime"
												value-format="yyyy-MM-dd HH:mm:ss"
												placeholder="选择日期"
											>
											</el-date-picker>
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="所接炉具:">
											<el-input
												placeholder="请输入"
												v-model="ruleForm.receiveStove"
											></el-input>
										</el-form-item>
									</el-col>
									<!-- <el-col :span="12">
										<el-form-item label="对接系统:">
											<el-radio-group
												v-model="ruleForm.tableSystem"
											>
												<el-radio :label="1"
													>卡表系统</el-radio
												>
												<el-radio :label="2"
													>营收系统</el-radio
												>
											</el-radio-group>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="识别号:">
											<el-input
												placeholder="请输入"
												v-model="
													ruleForm.identifyNumber
												"
											></el-input>
										</el-form-item>
									</el-col> -->
									<el-col :span="24">
										<el-form-item label="备注:">
											<el-input
												placeholder="请输入"
												v-model="ruleForm.remark"
											></el-input>
										</el-form-item>
									</el-col>
								</el-row>
							</div>
						</div>
					</el-form>
					<div class="btns">
						<!-- <el-button
							size="mini"
							style="height: 30px; margin-top: 5px"
							@click="backtrack"
							>取消</el-button
						> -->
						<el-button
							size="mini"
							type="primary"
							@click="save()"
							style="height: 30px; margin-top: 5px"
							>确定</el-button
						>
					</div>
				</div>
			</div>
		</div>
		<!-- 地图组件 -->
		<el-dialog
      :visible.sync="showModel"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <mapDialog ref="mapDialog" @closeModal="closeModal" :newForm="ruleForm.addressCoordDetail"></mapDialog>
    </el-dialog>
	<el-dialog
      title="图片预览"
      :visible.sync="dialogVisibleImg"
      width="80%"
      :close-on-click-modal="false"
    >
      <div><img :src="dialogImageUrl" fit="fit" /></div>
    </el-dialog>
	</div>
</template>


<script>
	import mapDialog from '../mapDialog'
	import { getAddrDropDown } from "@/RequestPort/workorder/maintenRecord";
	import { selectDictListByPid } from "@/RequestPort/device/deviceList";
	import { civilUserInsertOrUpdate } from "@/RequestPort/induction";
	import { uploadImg } from "@/RequestPort/apply/apply.js";
	export default {
		name: "peopleUserEdit",
		components:{mapDialog},
		data() {
			return {
				dialogImageUrl:'',
				dialogVisibleImg:false,
				repairBeforFileFormData: new FormData(),
				repairBeforFilefileList: [],
				ruleForm: {
					addressDescribe:'',
					picture:[]
				},
				showModel:false,
				rules: {
					residentName: [
						{
							required: true,
							message: "请输入户主姓名",
							trigger: "blur",
						},
						{ max: 25, message: "超出最大限制", trigger: "change" },
					],
					addressDescribe: [
						{ max: 30, message: "超出最大限制", trigger: "change" },
					],
					mobile: [
						{
							required: true,
							message: "请输入户主电话",
							trigger: "blur",
						}
					],
					idnumber: [
						{
							message: "请输入正确的身份证号",
							trigger: ["change"],
							pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
						},
					],
					userType: [
						{ required: true, message: "请选择", trigger: "change" },
					],
					address: [
						{ required: true, message: "请选择", trigger: "change" },
					],
					addrs: [
						{ required: true, message: "请选择", trigger: "change" },
					],
				},
				taskAddrdata: [],
				userTypes: [],
				tableDirectionData: [], //表向
				tableTypeData: [], //燃气表类型
				tableVenderData: [], //燃气表厂家
			};
		},
		created() {
			if (this.$route.query.obj) {
				let arr = [];
				let ruleForm = JSON.parse(this.$route.query.obj);
				if (ruleForm.addrId) arr.push(ruleForm.addrId);
				if (ruleForm.addrsId) arr.push(ruleForm.addrsId);
				this.$set(ruleForm, "addrs", arr);
				this.ruleForm = ruleForm;
				this.ruleForm.tableVender = ruleForm.tableVender?ruleForm.tableVender+'':'';
				this.ruleForm.tableDirection = ruleForm.tableDirection?ruleForm.tableDirection+'':'';
				this.ruleForm.tableType = ruleForm.tableType?ruleForm.tableType+'':'';
				this.ruleForm.fireState = ruleForm.fireState?ruleForm.fireState+'':'';
				if(ruleForm.picture&&ruleForm.picture.split(',').length>0){
					let arrs = []
					let arr = ruleForm.picture.split(',')
					arr.forEach((item,index)=>{
						let obj={
							url:item
						}
						arrs.push(obj)
						this.repairBeforFilefileList = arrs
					})
				this.ruleForm.picture = ruleForm.picture.split(',')

				}else{
					this.ruleForm.picture = []
				}
				if(ruleForm.addressCoord&&ruleForm.addressCoord!='@'&&ruleForm.addressCoord!=''){
					this.ruleForm.addressCoordDetail = this.ruleForm.addressCoord.split('@')[0]
				}
			}
			// 片区下拉
			this.gettaskAddrList();
			// 用户分类
			this.getuserTypeDropDown();
			// 表向
			this.getTableDirectio();
			// 燃气表类型
			this.geTtableType();
			// 燃气表厂家
			this.getTableVender();
		},
		methods: {
			changeAddress(){
				if(this.ruleForm.addressDescribe==''||this.ruleForm.addressDescribe==null){
					this.ruleForm.addressDescribe = this.ruleForm.address
				}
			},
			chooseLocation(){
				if(this.ruleForm.addressCoordDetail){
					this.showModel = true
					this.$nextTick(()=>{
					this.$refs.mapDialog.openL(this.ruleForm.addressCoord.split('@')[1].split(' ')[0]+' '+this.ruleForm.addressCoord.split('@')[1].split(' ')[1])
				}) 
				}else{
					this.showModel = true
				}
			},
			closeModal(address,location){
				console.log(location)
				this.showModel = false
				this.ruleForm.addressCoord =  address+"@"+location
				this.ruleForm.addressCoordDetail =  address
			},
			repairBeforUploadFun(e) {
				this.repairBeforFileFormData.append("file", e.file);
				uploadImg(this.repairBeforFileFormData).then((res) => {
					this.ruleForm.picture.push(res.data.url);
					this.repairBeforFileFormData.delete("file");
				});
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			handleRemove(file, fileList) {
				let index = this.getArrayIndex(this.repairBeforFilefileList, file);
				this.ruleForm.picture.splice(index, 1);
				this.repairBeforFilefileList.splice(index, 1);
			},
			getArrayIndex(arr, obj) {
				var i = arr.length;
				while (i--) {
					if (arr[i] === obj) {
					return i;
					}
				}
				return -1;
			},
			beforUploadImg(file) {
				const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);

				const whiteList = [
					"jpg",
					"jpeg",
					"png",
					"gif",
					"bmp",
					"JPG",
					"JPEG",
					"PBG",
					"GIF",
					"BMP",
				];
				if (whiteList.indexOf(fileSuffix) === -1) {
					this.$message.error("上传文件只能是 jpg、jpeg、png、gif、bmp");
					return false;
				}
				const size = file.size / 1024 / 1024;
				if (size > 100) {
					this.$message.error("大小必须小于100M");
					return false;
				}
				},
				msgLimit(file, fileList) {
					this.$message.error("只能上传20张图片");
				},
				beforHFhandleChangeImg(file, fileList) {
					this.repairBeforFilefileList = fileList;
				},
			/**
			 * 返回
			 */
			backtrack() {
				this.$router.push('/home/peopleUser')
			},
			/**
			 * 片区下拉
			 */
			gettaskAddrList() {
				getAddrDropDown().then((res) => {
					res.data.forEach(item=>{
						if(item.children){
						item.disable = false
						}else {
						item.disable = true
						}
						this.taskAddrdata = res.data
					})
				});
			},
			/***
			 * 用户分类
			 */
			getuserTypeDropDown() {
				selectDictListByPid({ pid: 732 }).then((res) => {
					this.userTypes = res.data;
				});
			},
			/***
			 * 表向
			 */
			getTableDirectio() {
				selectDictListByPid({ pid: 707 }).then((res) => {
					this.tableDirectionData = res.data;
				});
			},
			/***
			 * 燃气表类型
			 */
			geTtableType() {
				selectDictListByPid({ pid: 702 }).then((res) => {
					this.tableTypeData = res.data;
				});
			},
			/***
			 * 燃气表厂家
			 */
			getTableVender() {
				selectDictListByPid({ pid: 710 }).then((res) => {
					this.tableVenderData = res.data;
				});
			},
			restSearch() {
				this.ruleForm = {};
			},
			save() {
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {
						if(this.ruleForm.addressCoord == '@'){
							this.ruleForm.addressCoord = ''
						}
						if (this.ruleForm.addrs.length >= 2) {
							this.ruleForm.addrId = this.ruleForm.addrs[0];
							this.ruleForm.addrsId = this.ruleForm.addrs[1];
						}
						if (this.ruleForm.picture&&this.ruleForm.picture.length >= 0) {
							this.ruleForm.picture = this.ruleForm.picture.toString()
						}
						if(this.ruleForm.addressDescribe==''||this.ruleForm.addressDescribe==null){
							this.ruleForm.addressDescribe = this.ruleForm.address
						}
						civilUserInsertOrUpdate(this.ruleForm).then((res) => {
							this.$message.success(res.data);
							this.backtrack();
						});
					}
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	.content1 {
		position: relative;
		margin: 10px;
	}
	.all {
		padding: 10px;
		border-radius: 5px;
		background-color: #ffffff;
		padding-bottom: 30px;
		overflow: auto;
		box-sizing: border-box;
		height: calc(100vh - 91px);

		.btns {
			// position: absolute;
			// width: 99%;
			// left: 0;
			// bottom: 20px;
			text-align: center;
		}
		.peopleUserInfo {
			max-width: 1000px;
			margin-top: 10px;
			padding-left: 20px;
			.peopleUserList {
				.title {
					font-size: 18px;
					font-weight: bolder;
					margin-bottom: 10px;
				}
			}
		}
	}
</style>